import { createContext, useContext } from "react";

interface UserFilterContextType {
  selectedFilter: string;
  setUserFilter: (filter: string) => void;
}

const UserFilterContext = createContext<UserFilterContextType>({
  selectedFilter: "all",
  setUserFilter: () => {},
});

export const UserFilterProvider = UserFilterContext.Provider;

export const useUserFilterContext = () => useContext(UserFilterContext);
